import { useAppSelector } from '@/stores/hooks.ts'
import { b2cOneTimePaymentsSelectors } from '@/stores/slices/b2c-slice/b2c-one-time-payments-slice.ts'
import { b2cRegistryPaymentsSelectors } from '@/stores/slices/b2c-slice/b2c-registry-payments-slice.ts'
import { b2cSelectors, B2CTableState } from '@/stores/slices/b2c-slice/b2c-slice.ts'

export const useB2CState = (resettableKeyFilters: (keyof B2CTableState)[] = []) => {
  const b2cState = useAppSelector((state) => state.b2c.b2cState)
  const b2cRegistryState = useAppSelector((state) => state.b2c.b2cRegistryState)
  const b2cPaymentsType = useAppSelector((state) => state.b2c.b2cPaymentsType)
  const dateRange = useAppSelector((state) => [state.b2c.dateFrom, state.b2c.dateTo])
  const b2cType = useAppSelector((state) => state.b2c.b2cType)
  const b2cRegistryNumber = useAppSelector((state) => state.b2c.b2cRegistryNumber)
  const resettableStateFilters = useAppSelector((state) =>
    b2cSelectors.resettableStateFilters(state, resettableKeyFilters)
  )

  return { b2cState, b2cRegistryState, b2cPaymentsType, dateRange, b2cType, b2cRegistryNumber, resettableStateFilters }
}

export const useB2COneTimePaymentsTableState = () => {
  const { page, sort, showCount } = useAppSelector(b2cOneTimePaymentsSelectors.filters)

  return { page, sort, showCount }
}

export const useB2CRegistryPaymentsTableState = () => {
  const { page, sort, showCount } = useAppSelector(b2cRegistryPaymentsSelectors.filters)

  return { page, sort, showCount }
}
